import {FC, HTMLAttributes} from 'react';
import clsx from 'clsx';
import {AddressType} from 'types/address';

export type AddressProps = HTMLAttributes<HTMLElement> & {
    address: Partial<AddressType>;
    className?: string;
};

const Address: FC<AddressProps> = ({address, className, ...rest}) => {
    const addressFormat = address.addressFormat || 'default';

    return (
        <address
            className={clsx('not-italic text-grey-900', className)}
            role="complementary"
            {...rest}
        >
            {addressFormat === 'default' && (
                <>
                    {address.streetAddress && (
                        <>
                            <span>{address.streetAddress}</span>
                            <br />
                        </>
                    )}
                    {address.extendedAddress && (
                        <>
                            <span>{address.extendedAddress}</span>
                            <br />
                        </>
                    )}
                    {address.locality && (
                        <>
                            <span>{address.locality}</span>,&nbsp;
                        </>
                    )}
                    {address.region && (
                        <>
                            <span>{address.region}</span>&nbsp;
                        </>
                    )}
                    {address.postalCode && <span>{address.postalCode}</span>}
                </>
            )}
            {addressFormat === 'jp_default' && (
                <>
                    {address.postalCode && (
                        <>
                            〒<span>{address.postalCode}</span>
                            <br />
                        </>
                    )}
                    {address.region && <span>{address.region}</span>}
                    {address.locality && <span>{address.locality}</span>}
                    {address.streetAddress && (
                        <>
                            <span>{address.streetAddress}</span>
                            <br />
                        </>
                    )}
                    {address.extendedAddress && (
                        <span>{address.extendedAddress}</span>
                    )}
                </>
            )}
            {addressFormat === 'jp_western' && (
                <>
                    {address.extendedAddress && (
                        <>
                            <span>{address.extendedAddress}</span>
                            <br />
                        </>
                    )}
                    {address.streetAddress && (
                        <span>{address.streetAddress}</span>
                    )}
                    {address.locality && (
                        <>
                            <span>{address.locality}</span>
                            <br />
                        </>
                    )}
                    {address.region && <span>{address.region}</span>}
                    {address.postalCode && (
                        <>
                            <span>〒</span>
                            <span>{address.postalCode}</span>
                        </>
                    )}
                </>
            )}
        </address>
    );
};
export default Address;
